import constants from '../constants.json' assert { type: 'json' };
import React, { useContext } from 'react';
import '../styles/AccountLinks.css';
import { Link } from 'react-router-dom';
import { CustomerContext } from './context/CustomerContext';


const { ACCOUNT_LINKS, ACCOUNT_LINKS_FLAG } = constants;

const AccountLinks = () => {
    const {
        customerData,
        isCustomerDataLoaded,
    } = useContext(CustomerContext);
    return <div
        className={'account-links'}>
        <img
            alt={ACCOUNT_LINKS_FLAG.ALT_TEXT}
            src={ACCOUNT_LINKS_FLAG.IMAGE_URL}
            width={ACCOUNT_LINKS_FLAG.WIDTH}
            height={ACCOUNT_LINKS_FLAG.HEIGHT}
        />
        {ACCOUNT_LINKS.map((link) => {
            if (link.GUEST_ACCESS || (isCustomerDataLoaded && customerData.User)) {
                return (<Link
                    className={'custom-link'}
                    to={link.URL}
                    key={`${link.LABEL}`}>
                    {link.LABEL}
                </Link>);
            }
        })}
    </div>;
};

export default AccountLinks;